import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import ProductSection from './components/ProductSection';
import AboutSection from './components/AboutSection';
import Footer from './components/Footer';
import CallMeDialog from './register';
import img1 from './images/kits/k1.jpeg';
import img2 from './images/kits/k2.jpeg';
import img3 from './images/kits/k3.jpeg';
import kit2 from './images/kits/kit2.jpg';
import { useNavigate, useParams } from 'react-router';
import axios from 'axios';
import { Product } from './types';
function Contact()
{
    return (    
    <div className="min-h-screen">
      <Header />      
      <main>        
        {/* Intro Section */}
        <section className="py-24 bg-black p-20">
            <div className='container mt-7'>
                <div className='text-center'>
                    <h1>AMS COMPANY</h1>
                    <h1>MH 24, Second Floor, Shopprix Mall, Delhi Road, Meerut UP-250002</h1>
                    <h1>info@arvindmerasathi.com</h1>                    
                    <h1>+91-8126349977</h1>                    
                    <h1>9AM to 9PM, 7 days working</h1>                    
                </div>
            </div>
        </section>        
      </main>
      <Footer />
    </div>
  );  
}

export default Contact;
